/**
 * "Continue with Google", … — the social sign-in buttons' names, for every
 * provider in `SOCIAL_PROVIDERS`. The brand names are never translated; the
 * phrase around them is.
 *
 *   <SocialSignInButtons labels={useSocialProviderLabels()} … />
 */
import { SOCIAL_PROVIDER_NAME, SOCIAL_PROVIDERS, type SocialProvider } from '@tonnie/foundation';
import { useMemo } from 'react';

import { useTranslation } from './useTranslation';

export function useSocialProviderLabels(): Record<SocialProvider, string> {
  const { t } = useTranslation();
  return useMemo(
    () =>
      Object.fromEntries(
        SOCIAL_PROVIDERS.map((p) => [
          p,
          t('auth.social.continueWith', { provider: SOCIAL_PROVIDER_NAME[p] }),
        ])
      ) as Record<SocialProvider, string>,
    [t]
  );
}
